import client from './client';

const BASE_URL = '/api/v1/sys/jobs';

// =============================== 예약 작업 관리 ===============================

export const getJobList = () => client.get(BASE_URL);

export const getJobRuns = (jobId, page = 0, size = 20) =>
  client.get(`${BASE_URL}/${jobId}/runs?page=${page}&size=${size}`);

export const runJobManually = (jobId) => client.post(`${BASE_URL}/${jobId}/run`);

// 응답 봉투 키가 화면마다 data/info 로 다르게 내려와서 셋 다 받아 본다(eqpMonitor.js와 같은 방식).
export const extractPayload = (res) => {
  const d = res?.data;
  if (!d || typeof d !== 'object') return d ?? null;
  if (d.data !== undefined) return d.data;
  if (d.info !== undefined) return d.info;
  return d;
};

export const extractList = (res) => {
  const payload = extractPayload(res);
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.list)) return payload.list;
  return [];
};

export const extractTotal = (res) => {
  const payload = extractPayload(res);
  return Number(payload?.total) || 0;
};
